import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekButton = styled(Button)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h5), { textTransform: "capitalize", padding: `0 ${theme.spacing(1)}`, height: theme.spacing(2.8), minWidth: theme.spacing(6.5), borderRadius: theme.spacing(0.8), [theme.breakpoints.down("md")]: {
        height: theme.spacing(4.2),
    }, "&.MuiButton-outlined": {
        backgroundColor: theme.palette.secondary.contrastText,
        ":hover": {
            backgroundColor: theme.palette.secondary.contrastText,
        },
    }, "&.MuiButton-outlinedInfo": {
        color: theme.palette.text.primary,
        border: `${theme.spacing(0.05)} solid ${theme.palette.grey[100]}`,
        backgroundColor: theme.palette.secondary.contrastText,
        ":hover": {
            borderColor: theme.palette.secondary.main,
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
        },
    }, "&.Mui-disabled": {
        opacity: 0.5,
        color: theme.palette.grey[400],
    }, "&.MuiButton-sizeLarge": {
        padding: `${theme.spacing(1.8)} ${theme.spacing(1.5)}`,
    }, "> .MuiButton-endIcon": {
        marginLeft: 0,
    } })));

export { PeekButton, PeekButton as default };
